export default "__VITE_ASSET__DMWdwZa$__"